import { combinedActions } from "../../utils/actions";

export const getProfile = combinedActions<void, string>("GETPROFILE");
export const getProfileToken = combinedActions<void, string>("GETPROFILETOKEN");
